import React, { useEffect, useState } from 'react'
import { DisplacementArrow } from '../displacementArrow'
import s from './topImage.m.scss'
import { ColourVariation } from 'lib/colourVariation'
import { useInView } from 'react-intersection-observer'

interface Props {
  colours: ColourVariation
  current: number
  previous: string
  imageName?: string
}

export function TopImage({ colours, current, previous, imageName }: Props) {
  const [src, setSrc] = useState<string>()
  const [srcSet, setSrcSet] = useState<string>()
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '200px'
  })

  // Load placeholder image
  useEffect(() => {
    if (imageName && imageName.length > 0) {
      import(
        /* webpackMode: "lazy-once" */
        /* webpackChunkName: "placeholder" */
        `images/hotels/${imageName}.jpg?placeholder`
      ).then(obj => {
        setSrc(obj.placeholder.url)
      })
    }
  }, [imageName])

  useEffect(() => {
    if (inView && imageName && imageName.length > 0) {
      import(
        /* webpackMode: "lazy" */
        /* webpackChunkName: "hotel" */
        `images/hotels/${imageName}.jpg?sizes=175w+350w+700w+1024w`
      ).then(obj => {
        setSrc(obj.sources['350w'])
        setSrcSet(obj.srcSet)
      })
    }
  }, [imageName, inView])

  const topImageStyles = {
    backgroundColor: colours.gradientStart
  }

  return (
    <div ref={ref} className={s.topImage} style={topImageStyles}>
      {src && (
        <div
          style={{
            position: 'relative'
          }}
        >
          <img
            className={s.image}
            src={src}
            srcSet={srcSet}
            alt=''
            sizes={
              '(max-width:' +
              ' 599px) 95vw, (max-width: 899px) 45vw, (max-width: 1199px) 32vw, 347px'
            }
          />
        </div>
      )}
      <div
        className={s.rankContainer}
        style={{
          backgroundImage: `linear-gradient(
                  135deg,
                  ${colours.transparentGradientStart} ${!src ? '0%' : '60%'},
                  ${colours.gradientEnd} 90%)`
        }}
      >
        <div className={s.rank}>
          <div className={s.previousRank}>{previous}</div>
          <DisplacementArrow current={current} previous={previous} />
          <div className={s.currentRank}>{current}</div>
        </div>
      </div>
    </div>
  )
}
